import * as React from "react";
const SvgDiameterPipe = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 101.5 101.51",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("radialGradient", {
	id: "diameter-pipe_svg__a",
	cx: 50.63,
	cy: 50.75,
	r: 50.75,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .81,
	stopColor: "#424344"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .91,
	stopColor: "#6a6f72"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#4a5157"
}))), /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("path", {
	d: "M96.61 29A50.67 50.67 0 0 0 50.75 0 50.78 50.78 0 0 0 0 50.75a50.1 50.1 0 0 0 5.54 23 50.73 50.73 0 0 0 90.85-.87A50.66 50.66 0 0 0 96.61 29m-7 34A40.66 40.66 0 0 1 68 87.69a40.1 40.1 0 0 1-17.3 3.86 40.69 40.69 0 0 1-38-26 40.38 40.38 0 0 1-.26-28.87A40.79 40.79 0 0 1 88.78 36a40.2 40.2 0 0 1 2.77 14.74A39.8 39.8 0 0 1 89.64 63Z",
	style: { fill: "url(#diameter-pipe_svg__a)" }
}), /* @__PURE__ */ React.createElement("path", { d: "m34.5 69.92 6.26 6.25-8.69.96-8.7.96.96-8.7.96-8.69 6.26 6.26 35.21-35.22-6.25-6.25 8.7-.97 8.69-.97-.95 8.71-.98 8.7-6.25-6.26z" }))));
export default SvgDiameterPipe;
